import React, {Component} from 'react';
import { connect } from 'react-redux';
import Input from '../../UI/Input/Input';
import Button from '../../UI/Button/Button';
import {MDM_SEARCH, MDM_SEARCH_MESSAGE, MDM_SEARCH_TYPE, SESSION_SUPERUSER, SESSION_SUPERVISORUSER, SESSION_TIER1USER, SESSION_USERTYPE, TMX_FAILURE, TMX_FAILURE_EVENT_NUM}  from "../../shared/Constants";
import DisplayBox from '../../hoc/DisplayBox/DisplayBox';
import classes from './MdmSearch.css';
import admSvc from '../../axios-admsvc';
import MdmSearchResult from '../../components/MdmSearchResult/MdmSearchResult';
import Spinner from '../../UI/Spinner/Spinner';
import Message from '../../components/Message/Message';
import { checkValidity } from "../../shared/utility";
import { FETCH_AGENT_ACTIVITY_SEARCH_RESULT } from '../../shared/ApplicationUrls';
import * as actions from '../../store/actions/index';

const TMX_CHECK_USER_TYPES = [
    SESSION_TIER1USER,
    SESSION_SUPERVISORUSER,
    SESSION_SUPERUSER
];

// at least one of these must be filled and valid to enable search
const REQUIRED_SEARCH_FIELDS = ['givenName', 'lastName', 'dateOfBirth'];

export class MdmSearch extends Component {

    state = {
        searchForm: {
            givenName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'firstName',
                    placeholder: 'first name'
                },
                value: '',
                validation: {
                    required: true,
                    minlength: 3,
                    specialchar: ['<','"','+',':',';','=','\\','*','&','(',')','#']
                },
                valid: false,
                touched: false,
                label: "First Name",
                inputType: "OneThird"
            },
            lastName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'lastName',
                    placeholder: 'last name'
                },
                value: '',
                validation: {
                    required: true,
                    minlength: 3,
                    specialchar: ['<','"','+',':',';','=','\\','*','&','(',')','#']
                },
                valid: false,
                touched: false,
                label: "Last Name",
                inputType: "OneThird"
            },
            dateOfBirth: {
                elementType: 'input',
                elementConfig: {
                    type: 'date',
                    id: 'dob',
                    placeholder: 'mm/dd/yyyy'
                },
                value: '',
                validation: {
                    required: true,
                    restrictFuture: true
                },
                valid: false,
                touched: false,
                label: "DOB",
                inputType: "OneThird"
            },
            zipCode: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'zipCode',
                    placeholder: '12345',
                    maxLength: 5,
                    pattern: '[0-9]{1,9}',
                    title:'Zip can only contain numbers'
                },
                value: '',
                validation: {
                    required: false,
                    minlength: 5,
                    maxlength: 5
                },
                valid: true,
                touched: false,
                label: "Zip(Optional)",
                inputType: "OneThird"
            },
            social: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'social',
                    placeholder: 'social',
                    maxLength: 9,
                    pattern: '[0-9]{1,9}',
                    title:'Social can only contain numbers'
                },
                value: '',
                validation: {
                    required: false,
                    minlength: 9,
                    maxlength: 9
                },
                valid: true,
                touched: false,
                label: "SSN(Optional)",
                inputType: "OneThird"
            },
            memberId: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'memberId',
                    placeholder: '123456789',
                    maxLength: 15
                },
                value: '',
                validation: {
                    required: false,
                    minlength: 3,
                    maxlength: 15
                },
                valid: true,
                touched: false,
                label: "Member ID(Optional)",
                inputType: "OneThird"
            }
        },
        formHeader: MDM_SEARCH,
        selectedMember: null,
        isError: null,
        formIsValid: false,
        loading: false,
        msg: MDM_SEARCH_MESSAGE,
        searchResult: null,
        error: null,
        greyResults: false
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        this.restorePersistedSearch();
    }

    restorePersistedSearch = () => {
        const persistedRequest = this.props.persistedSearchRequest;
        if (!persistedRequest) {
            return;
        }

        const updatedForm = {...this.state.searchForm};
        for (let inputIdentifier in updatedForm) {
            const value = persistedRequest[inputIdentifier] !== undefined && persistedRequest[inputIdentifier] !== null
                ? persistedRequest[inputIdentifier]
                : '';
            const updatedFormElement = {...updatedForm[inputIdentifier]};
            updatedFormElement.value = value;
            // empty fields are valid here; isFormValid enforces at least one of REQUIRED_SEARCH_FIELDS
            updatedFormElement.valid = value ? checkValidity(value, updatedFormElement.validation).isValid : true;
            updatedFormElement.touched = !!value;
            updatedForm[inputIdentifier] = updatedFormElement;
        }
        const formIsValid = this.isFormValid(updatedForm);

        this.setState({searchForm: updatedForm, formIsValid: formIsValid});

        if (formIsValid) {
            this.executeMdmSearch(persistedRequest);
        }
    }

    tmxEvent = 'registration';
    tmxSuccessStatus = 'SUCCESS';
    tmxFailureStatus = 'FAILURE';

    filterData = (data) => {
        const formData = {};
        formData['firstName'] = data[0].firstName;
        formData['lastName'] = data[0].lastName;
        formData['dob'] = data[0].dob;
        formData['page'] = 1;
        formData['pageSize'] = TMX_FAILURE_EVENT_NUM;
        formData['event'] = 'registration';
        formData['eventType'] = 'USER';
        const portalSuccessfulRegistration = new Set();
        admSvc.post(FETCH_AGENT_ACTIVITY_SEARCH_RESULT, formData).then(response => {
            const events = response.data.payload.events;
            let isTmxFailed = false;
            for(const eventIndx in events) {
                if(events[eventIndx].eventStatus === TMX_FAILURE
                && !portalSuccessfulRegistration.has(events[eventIndx]?.metaData?.targetPortal)) {
                    isTmxFailed = true;
                    break;
                }else if (events[eventIndx].eventStatus === 'SUCCESS') {
                    portalSuccessfulRegistration.add(events[eventIndx]?.metaData?.targetPortal);
                }
            }
            const userType = localStorage.getItem(SESSION_USERTYPE);
            const isSuperUser = userType === SESSION_SUPERUSER;
            if (isTmxFailed) {
                this.setState({
                    loading: false, 
                    searchResult: data, 
                    error: {
                        code:'SUCCESS',
                        message: isSuperUser
                            ? "Error 20001: Please defer to established TMX workflows to assist the member further."
                            : "Error 20001: Please advise the caller to contact the toll-free number (TFN) provided within the 20001 error message displayed on the webpage for further assistance."
                    },
                    greyResults: !isSuperUser
                });
            }else {
                this.setState({
                    loading: false, 
                    searchResult: data, 
                    error: null,
                    greyResults: false
                });
            }
        }).catch(error => {
            let errorMessage = "Oops! Something didn't go as planned. Pls try again.";
            if(error && error.response && error.response.status === 500){
                errorMessage = "MDM service is not available. Pls try again."
            } 
            this.setState({loading: false, error: {message: errorMessage }});
            // return Promise.reject(error.response);
            return error.response;
        });
    }

    isGreyingEnabled = (response) => {
        if (response.data.error) {
            this.setState(
                {
                    loading: false, 
                    searchResult: response.data.payload, 
                    error: response.data.status,
                    greyResults: true
                }
            );
            return
        }
        this.filterData(response.data.payload)
    }

    inputChangedHandler =(event, inputIdentifier) => {

        let updatedForm = {...this.state.searchForm};

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.value = event.target.value;

        if(event.target.value) {
            const validation = checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.valid = validation.isValid;
            this.setState({error: {message: validation.message}});
        } else {
            updatedFormElement.valid = true;
            this.errorHandler(null);
        }

        // updatedFormElement.valid = this.checkValidity(updatedFormElement.value, updatedFormElement.validation);
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        const formIsValid = this.isFormValid(updatedForm);
        // console.log("[MDMDSearch] input change handler", updatedForm, formIsValid);
        this.setState({searchForm: updatedForm, formIsValid: formIsValid});
    }

    isFormValid = (form) => {
        let formIsValid = true;
        let atLeastOneRequiredValid = false;
        for (let inputIdentifier in form) {
            const field = form[inputIdentifier];
            if (REQUIRED_SEARCH_FIELDS.includes(inputIdentifier)) {
                if (field.valid && field.value) {
                    atLeastOneRequiredValid = true;
                }
            } else {
                formIsValid = field.valid && formIsValid;
            }
        }
        return formIsValid && atLeastOneRequiredValid;
    }

    mdmSearchHandler = (event) => {
        event.preventDefault();
        const searchRequest = {};
        for(let formElementIdentifier in this.state.searchForm) {
            if(this.state.searchForm[formElementIdentifier].value !== "") {
                searchRequest[formElementIdentifier] = this.state.searchForm[formElementIdentifier].value;
            }
        }
        this.props.setPersistedSearchRequest(MDM_SEARCH_TYPE, searchRequest);
        this.executeMdmSearch(searchRequest);
    }

    clearSearch = () => {
        const searchForm = {...this.state.searchForm};
        for (const inputIdentifier in searchForm) {
            const searchFormElement = {...searchForm[inputIdentifier]};
            searchFormElement.value = '';
            searchFormElement.touched = false;
            searchFormElement.valid = !searchFormElement.validation.required;
            searchForm[inputIdentifier] = searchFormElement;
        }

        this.props.clearPersistedSearchRequest(MDM_SEARCH_TYPE);
        this.setState({
            searchForm,
            formIsValid: false,
            searchResult: null,
            error: null,
            greyResults: false
        });
    }

    buildMdmPayload = (searchRequest) => {
        const formData = {};
        for(let field in searchRequest) {
            if(searchRequest[field] === "" || searchRequest[field] === null || searchRequest[field] === undefined) {
                continue;
            }
            if(field === "social") {
                formData.identificationType = "1";
                formData.identificationNumber = searchRequest[field];
            } else {
                formData[field] = searchRequest[field];
            }
        }
        return formData;
    }

    executeMdmSearch = (searchRequest) => {
        const formData = this.buildMdmPayload(searchRequest);
        this.setState({loading: true, error: null, searchResult: null});
        // POST /hsid/admin/members/mdm
        return admSvc.post("/members/mdm/search", formData,).then(response => {
                // console.log("[MdmSearch] MdmSearch Response: ",response?.data?.payload);
                const userType = localStorage.getItem(SESSION_USERTYPE);
                const shouldRunTmxCheck = TMX_CHECK_USER_TYPES.includes(userType);

                if (shouldRunTmxCheck) {
                    this.isGreyingEnabled(response);
                }else {
                    this.setState(
                        {
                            loading: false, 
                            searchResult: response.data.payload, 
                            error: response.data.status
                        }
                     );
                }
            }).catch(error => {
                let errorMessage = "Oops! Something didn't go as planned. Pls try again.";
                if(error && error.response && error.response.status === 500){
                    errorMessage = "MDM service is not available. Pls try again."
                } 
                this.setState({loading: false, error: {message: errorMessage }});
                // return Promise.reject(error.response);
                return error.response;
            });
    }

    mdmMemberSelectionHandler = (data, index) => {
        //console.log("[MdmSearch] mdmMemberSelectionHandler", data);
        this.props.history.push("/mdmMember", data);
    }

    errorHandler = (errObj) => {
        this.setState({error: errObj});
    }

    render() {

        // show spinner when form is loading
        const showSpinner = this.state.loading? <Spinner/>: null;

        //create search form
        const formsElementsArray =[];
        for(let key in this.state.searchForm) {
            formsElementsArray.push({
                id: key,
                config: this.state.searchForm[key]
            });
        }

        // Search Results
        let mdmSearchForm = (
            <form onSubmit={this.mdmSearchHandler}>
                <div>
                    {formsElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            label={formElement.config.label}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            inputType={formElement.config.inputType}
                        />
                    ))}
                </div>
                <div style={{display:"flex", justifyContent:"center"}}>
                    <Button id="clearSearch" btnType="Cancel" clicked={this.clearSearch} attr={{type: "button"}}>Clear All</Button>
                    <Button id="search" btnType="Search" disabled={!this.state.formIsValid}>Search</Button>
                </div>
            </form>
        );
        

        // search result list
        let mdmSearchResult = <MdmSearchResult
            searchResult = {this.state.searchResult}
            selected={this.mdmMemberSelectionHandler} 
            isGreyingEnabled={this.state.greyResults}
            />;

        return (
            <DisplayBox>
                <div className={classes.SearchWindow}>
                    <h2 className={classes.FormTitle}>{this.state.formHeader}</h2>
                    <p className={classes.Message}>{this.state.msg}</p>
                    <Message msgType="Error" info={this.state.error} />
                    {mdmSearchForm}
                    {showSpinner}
                    {mdmSearchResult}
                </div>
            </DisplayBox>
        );
    }
}
export const mapStateToProps = state => {
    return {
        persistedSearchRequest: actions.getPersistedSearchRequest(state, MDM_SEARCH_TYPE)
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        setPersistedSearchRequest: (searchType, request) => dispatch(actions.setPersistedSearchRequest(searchType, request)),
        clearPersistedSearchRequest: (searchType) => dispatch(actions.clearPersistedSearchRequest(searchType)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MdmSearch);
